import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccProfessionalIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccProfessionalIcon(props: MccProfessionalIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('MccProfessionalIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Professional')}
      {...rest}
    >
      <path
        d="M5.33331 13V3.66667C5.33331 3.04669 5.33331 2.7367 5.40146 2.48236C5.5864 1.79218 6.12549 1.25308 6.81568 1.06815C7.07001 1 7.38 1 7.99998 1C8.61996 1 8.92995 1 9.18428 1.06815C9.87447 1.25308 10.4136 1.79218 10.5985 2.48236C10.6666 2.7367 10.6666 3.04669 10.6666 3.66667V13M3.46665 13H12.5333C13.28 13 13.6534 13 13.9386 12.8547C14.1895 12.7268 14.3935 12.5229 14.5213 12.272C14.6666 11.9868 14.6666 11.6134 14.6666 10.8667V5.8C14.6666 5.05326 14.6666 4.6799 14.5213 4.39468C14.3935 4.1438 14.1895 3.93982 13.9386 3.81199C13.6534 3.66667 13.28 3.66667 12.5333 3.66667H3.46665C2.71991 3.66667 2.34654 3.66667 2.06133 3.81199C1.81044 3.93982 1.60647 4.1438 1.47864 4.39468C1.33331 4.6799 1.33331 5.05326 1.33331 5.8V10.8667C1.33331 11.6134 1.33331 11.9868 1.47864 12.272C1.60647 12.5229 1.81044 12.7268 2.06133 12.8547C2.34654 13 2.71991 13 3.46665 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
